import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { decryptUserId } from '../../../../utils/getUserDetails';
import { getTimeZones } from '../../../../service/timeZones/timeZoneService';
import Stapper from '../../../../components/common/stapper/stapper';
import Input from '../../../../components/common/input/input';
import Components from '../../../../components/muiComponents/components';
import { Controller, useForm } from 'react-hook-form';
import Button from '../../../../components/common/buttons/button';
import { getAllTeams } from '../../../../service/teamDetails/teamDetailsService';
import Select from '../../../../components/common/select/select';
import { getAllTeamMembers } from '../../../../service/teamMembers/teamMembersService';
import CustomIcons from '../../../../components/common/icons/CustomIcons';
import { getAllEventTypeList } from '../../../../service/calendar/calendarAppointmentEventType/calendarAppointmentEventTypeService';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { userTimeZone } from '../../../../service/common/commonService';
import { createTheme, ThemeProvider, useTheme, Badge } from '@mui/material';
import { freeSlotList, saveAppointment } from '../../../../service/calendar/calendarAppointment/calendarAppointmentService';
import { connect } from 'react-redux';
import { setAlert } from '../../../../redux/commonReducers/commonReducers';
import { getCustomer } from '../../../../service/customers/customersService';

const CustomDay = (props) => {
    const {
        day,
        outsideCurrentMonth,
        selected,
        selectedSlotsCountMap = {},
        sx,
        ...otherProps
    } = props;

    const dateStr = day.format("MM/DD/YYYY");
    const count = !outsideCurrentMonth ? (selectedSlotsCountMap[dateStr] || 0) : 0;
    const hasSelectedSlots = count > 0;

    return (
        <Badge
            key={day.toString()}
            overlap="circular"
            badgeContent={hasSelectedSlots ? count : undefined}
            sx={{
                '& .MuiBadge-badge': {
                    backgroundColor: '#d97706',
                    color: '#ffffff',
                    fontSize: '0.65rem',
                    fontWeight: 700,
                    height: 18,
                    minWidth: 18,
                    borderRadius: '9px',
                    padding: '0 3px',
                    border: '2px solid #ffffff',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
                    top: 5,
                    right: 5,
                    zIndex: 2,
                    pointerEvents: 'none',
                }
            }}
        >
            <PickersDay
                {...otherProps}
                day={day}
                outsideCurrentMonth={outsideCurrentMonth}
                selected={selected}
                sx={{
                    ...sx,
                    ...(hasSelectedSlots && !selected ? {
                        backgroundColor: '#FEF3C7 !important',
                        color: '#92400E !important',
                        fontWeight: '700 !important',
                        border: '1.5px solid #F59E0B !important',
                        '&:hover': {
                            backgroundColor: '#FDE68A !important',
                        }
                    } : {}),
                    ...(hasSelectedSlots && selected ? {
                        fontWeight: '700 !important',
                        boxShadow: '0 0 0 2px #F59E0B !important',
                    } : {})
                }}
            />
        </Badge>
    );
};
const formatDuration = (hours, minutes) => {
    if (hours && minutes) {
        const pad = (num) => String(num).padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)} Hour`;
    }
    if (hours) {
        return `${hours} Hour${hours > 1 ? 's' : ''}`;
    }
    if (minutes) {
        return `${minutes} Min`;
    }
    return '';
};

const steps = ["", "", "", "", "", ""];

const Appointment = ({ setAlert }) => {
    const theme = useTheme();
    const customTheme = createTheme({
        components: {
            MuiDayCalendar: {
                styleOverrides: {
                    weekDayLabel: {
                        color: '#000000',
                    }
                }
            },
            MuiPickersDay: {
                styleOverrides: {
                    root: {
                        color: "#000000",
                        "&:hover": {
                            backgroundColor: theme.palette.secondary.main,
                            color: "#ffffff",
                        },
                        "&.Mui-selected": {
                            backgroundColor: `${theme.palette.secondary.main} !important`,
                            color: "#ffffff !important",
                        },
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        color: "#000000",
                    },
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: theme.palette.text.primary,
                    },
                },
            },
            MuiPickersCalendarHeader: {
                styleOverrides: {
                    root: {
                        color: "#000000",
                    },
                },
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        color: "#000000",
                    },
                },
            },
        },
    });
    const [searchParams] = useSearchParams();
    const encryptedVal = searchParams.get('v');
    const emailParam = searchParams.get('email');
    const fromParam = searchParams.get('from');
    const isFromContacts = fromParam === 'contacts';
    const decryptedUserId = decryptUserId(encryptedVal);

    const [activeStep, setActiveStep] = useState(0);
    const [timeZoneList, setTimeZoneList] = useState([])
    const [teams, setTeams] = useState([])
    const [events, setEvents] = useState([])
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [teamEmails, setTeamEmails] = useState([]);
    const [guestEmails, setGuestEmails] = useState([]);
    const [emailInput, setEmailInput] = useState("");
    const [guestEmailsInitialized, setGuestEmailsInitialized] = useState(false);
    const inputRef = useRef(null);
    const [userDetails, setUserDetails] = useState({});

    const {
        handleSubmit,
        control,
        watch,
        setValue,
        register,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: "",
            email: "",
            teamId: "",
            selectedMembers: [],
            memTimeZone: userTimeZone || "",
            slotTimeMinus: "",
            currentDateYN: "",
            start: "",
            end: "",
            description: "",
            calAetId: ""
        },
    });

    const selectedEvent = events?.find(e => e.id === watch("calAetId"));

    const [slots, setSlots] = useState([]);
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [lastDateTz, setLastDateTz] = useState({ date: "", tz: "" });

    const selectedSlotsCountMap = useMemo(() => {
        const map = {};
        for (const slot of selectedSlots) {
            if (slot.date) {
                map[slot.date] = (map[slot.date] || 0) + 1;
            }
        }
        return map;
    }, [selectedSlots]);

    const formatSlotTime = (timeStr) => {
        if (!timeStr) return "";
        const [hourStr, minuteStr] = timeStr.split(":");
        const hour = parseInt(hourStr, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
        const paddedHour = String(formattedHour).padStart(2, '0');
        return `${paddedHour}:${minuteStr} ${ampm}`;
    };

    const handleGetFreeSlots = async () => {
        const selectedTzId = watch("memTimeZone");
        if (selectedDate && selectedTzId && selectedEvent) {
            setSlotsLoading(true);
            try {
                const selectedTzObj = timeZoneList?.find(tz => tz.id === selectedTzId);
                const tzValue = selectedTzObj ? selectedTzObj.value : "";

                const isToday = selectedDate.isSame(dayjs(), 'day');
                const currentDateYNVal = isToday ? "Y" : "N";
                setValue("currentDateYN", currentDateYNVal);

                const payload = {
                    slotTimeMinus: (selectedEvent.durationHours * 60) + (selectedEvent.durationMinutes || 0),
                    slotDateTime: selectedDate.format("MM/DD/YYYY"),
                    slotUserId: String(decryptedUserId),
                    timeZone: tzValue,
                    currentDateYN: currentDateYNVal
                };

                const res = await freeSlotList(userTimeZone, payload);
                if (res?.status === 200) {
                    setSlots(res?.result?.freeSlotList || []);
                } else {
                    setSlots([]);
                }
            } catch (error) {
                console.error("Error fetching free slots:", error);
                setSlots([]);
            } finally {
                setSlotsLoading(false);
            }
        } else {
            setSlots([]);
        }
    };

    const handleSelectSlot = (slot) => {
        const dateStr = selectedDate.format("MM/DD/YYYY");
        const startDateTime = `${dateStr} ${slot}`;

        const durationMinutes = (selectedEvent.durationHours * 60) + (selectedEvent.durationMinutes || 0);
        const startDayjs = dayjs(`${dateStr} ${slot}`, "MM/DD/YYYY HH:mm:ss");
        const endDayjs = startDayjs.add(durationMinutes, 'minute');
        const endDateTime = endDayjs.format("MM/DD/YYYY HH:mm:ss");

        const existingIndex = selectedSlots.findIndex(s => s.start === startDateTime);
        let updated;
        if (existingIndex > -1) {
            updated = selectedSlots.filter((_, idx) => idx !== existingIndex);
        } else {
            const selectedDays = Array.from(new Set(selectedSlots.map(s => s.date)));
            const isDateAlreadySelected = selectedDays.includes(dateStr);
            if (!isDateAlreadySelected && selectedDays.length >= 5) {
                setAlert({
                    open: true,
                    type: 'warning',
                    message: 'You can select slots for a maximum of 5 days only.',
                });
                return;
            }
            updated = [...selectedSlots, { start: startDateTime, end: endDateTime, slotTime: slot, date: dateStr }];
        }
        // Chronological sort across days and times
        updated.sort((a, b) => {
            const timeA = dayjs(a.start, "MM/DD/YYYY HH:mm:ss").valueOf();
            const timeB = dayjs(b.start, "MM/DD/YYYY HH:mm:ss").valueOf();
            return timeA - timeB;
        });
        setSelectedSlots(updated);

        if (updated.length > 0) {
            setValue("start", updated[0].start, { shouldValidate: true });
            setValue("end", updated[0].end, { shouldValidate: true });
        } else {
            setValue("start", "", { shouldValidate: true });
            setValue("end", "", { shouldValidate: true });
        }
    };

    const handleBack = () => {
        if (activeStep !== 0) {
            setActiveStep((prev) => prev - 1);
        }
    };

    const handleGetTimeZones = async () => {
        const res = await getTimeZones()
        if (res.status === 200) {
            const data = res?.result?.map((row) => {
                return {
                    id: row.tmzId,
                    title: row.tmzTitle,
                    value: row.tmzValue
                }
            })
            setTimeZoneList(data)
            const defaultTz = data?.find(row => row.value === userTimeZone);
            if (defaultTz) {
                setValue("memTimeZone", defaultTz.id);
            }
        }
    }

    const handleGetAllTeams = async () => {
        const res = await getAllTeams(decryptedUserId);
        if (res.status === 200) {
            const formattedTeams = res.result?.reverse()?.map((row, index) => ({
                id: row.id,
                title: row.name,
            }));
            setTeams(formattedTeams);
        }
    }

    const handleGetAllTeamMembers = async () => {
        try {
            const res = await getAllTeamMembers(watch("teamId"))
            if (res?.status === 200 && Array.isArray(res?.result)) {
                const emails = res.result?.map(row => row?.email).filter(Boolean);
                setTeamEmails(emails);
                setValue("selectedMembers", emails);
            }
        } catch (error) {
            console.error("Error fetching team members:", error);
        }
    }

    const handleGetAllEventTypes = async () => {
        if (activeStep === 2) {
            const res = await getAllEventTypeList(decryptedUserId)
            if (res?.status === 200) {
                setEvents(res?.result)
            }
        }
    }

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleWrapperClick = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            const trimmed = emailInput.trim().replace(/,/g, '');
            if (trimmed) {
                if (validateEmail(trimmed)) {
                    if (!guestEmails.includes(trimmed)) {
                        setGuestEmails([...guestEmails, trimmed]);
                    }
                    setEmailInput('');
                } else {
                    setAlert({
                        open: true,
                        type: 'error',
                        message: 'Please enter a valid email address.',
                    });
                }
            }
        }
    };

    const handleRemoveGuestEmail = (indexToRemove) => {
        setGuestEmails(guestEmails.filter((_, index) => index !== indexToRemove));
    };

    const handleGetUserDetails = async () => {
        try {
            if (decryptedUserId) {
                const res = await getCustomer(decryptedUserId)
                if (res?.data.status === 200) {
                    setUserDetails(res?.data?.result)
                }
            }
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
    }

    const onSubmit = async (data) => {
        if (activeStep === 4) {
            try {
                const selectedTzId = watch("memTimeZone");
                const selectedTzObj = timeZoneList?.find(tz => tz.id === selectedTzId);
                const tzValue = selectedTzObj ? selectedTzObj.value : "";

                const formattedTimeSlots = selectedSlots.map(s => ({
                    start: s.start,
                    end: s.end
                }));

                const payload = {
                    calAetId: watch("calAetId"),
                    title: watch("name"),
                    description: watch("description") || "",
                    start: formattedTimeSlots[0]?.start || "",
                    end: formattedTimeSlots[0]?.end || "",
                    timeSlots: formattedTimeSlots,
                    calTimeZone: tzValue,
                    calAttendees: JSON.stringify({ attendees: [...guestEmails, watch("email")] }),
                    customerId: decryptedUserId,
                    slotTimeMinus: (selectedEvent.durationHours * 60) + (selectedEvent.durationMinutes || 0),
                    contactList: [],
                    currentDateYN: watch("currentDateYN"),
                    memTimeZone: tzValue,
                    directBooking: isFromContacts && formattedTimeSlots.length === 1
                };
                const res = await saveAppointment(payload);
                if (res.status === 200) {
                    setActiveStep((prev) => prev + 1);
                } else {
                    setAlert({ open: true, message: res?.message || "Failed to schedule meeting.", type: 'error' });
                }
            } catch (error) {
                console.error("Error scheduling meeting:", error);
                setAlert({ open: true, message: error?.message || "An error occurred.", type: 'error' });
            }
        } else if (activeStep === 3) {
            if (selectedSlots.length === 0) {
                setAlert({ open: true, message: "Please select at least one time slot.", type: 'error' });
                return;
            }
            const selectedDays = Array.from(new Set(selectedSlots.map(s => s.date)));
            if (selectedDays.length > 5) {
                setAlert({ open: true, message: "You can select slots for a maximum of 5 days only.", type: 'warning' });
                return;
            }
            setActiveStep((prev) => prev + 1);
        } else {
            setActiveStep((prev) => prev + 1);
        }
    }

    useEffect(() => {
        handleGetUserDetails()
        handleGetTimeZones()
        handleGetAllTeams()
        // if (emailParam) {
        //     setValue("email", emailParam);
        // }
    }, [])

    useEffect(() => {
        if (watch("teamId")) {
            handleGetAllTeamMembers()
        } else {
            setTeamEmails([]);
            setValue("selectedMembers", []);
        }
    }, [watch("teamId")])

    useEffect(() => {
        handleGetAllEventTypes()
    }, [activeStep])

    useEffect(() => {
        if (activeStep === 3) {
            const dateStr = selectedDate?.format("MM/DD/YYYY") || "";
            const tzId = watch("memTimeZone");

            if (lastDateTz.tz !== tzId) {
                setSelectedSlots([]);
                setValue("start", "");
                setValue("end", "");
                setLastDateTz({ date: dateStr, tz: tzId });
            } else if (lastDateTz.date !== dateStr) {
                setLastDateTz({ date: dateStr, tz: tzId });
            }
            handleGetFreeSlots();
        }
    }, [selectedDate, watch("memTimeZone"), activeStep]);

    useEffect(() => {
        if (activeStep === 4 && !guestEmailsInitialized) {
            const initialEmails = [...teamEmails];
            if (isFromContacts && emailParam && !initialEmails.includes(emailParam)) {
                initialEmails.push(emailParam);
            }
            setGuestEmails(initialEmails);
            setGuestEmailsInitialized(true);
        } else if (activeStep !== 4) {
            setGuestEmailsInitialized(false);
        }
    }, [activeStep, teamEmails, guestEmailsInitialized, isFromContacts, emailParam]);

    return (
        <div className="min-h-screen flex-row items-start justify-center bg-gray-50 p-4">
            <div className='text-center'>
                <p className='text-3xl font-medium text-black'>
                    Welcome to 360Pipe's Meeting Scheduling with {userDetails?.firstName + ' ' + userDetails?.lastName}
                </p>
                <p className="text-sm font-medium text-gray-700 mt-1">
                    Please select meeting type and follow the instruction to add meeting to my calendar.
                </p>
            </div>

            <div className={`w-full mx-auto transition-all duration-300 ${activeStep === 4 ? 'max-w-4xl' : 'max-w-xl'}`}>
                <div className="my-8 flex justify-center">
                    <Stapper steps={steps} activeStep={activeStep} orientation="horizontal" width={700} />
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    {
                        activeStep === 0 && (
                            <div className="grid grid-cols-1 gap-4">
                                <div>
                                    <Controller
                                        name="name"
                                        control={control}
                                        rules={{
                                            required: "Name is required",
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                label="Name"
                                                type="text"
                                                error={errors?.name}
                                                onChange={(e) => {
                                                    field.onChange(e.target.value);
                                                }}
                                            />
                                        )}
                                    />
                                </div>

                                <div>
                                    <Controller
                                        name="email"
                                        control={control}
                                        rules={{
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "Invalid email address",
                                            },
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                label="Email"
                                                type={`text`}
                                                error={errors?.email}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\s/g, "");
                                                    field.onChange(value);
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        )
                    }
                    {
                        activeStep === 1 && (
                            <div className="grid grid-cols-1 gap-4">
                                <div>
                                    <Controller
                                        name="teamId"
                                        control={control}
                                        // rules={{ required: "Team is required" }}
                                        render={({ field }) => (
                                            <Select
                                                options={teams}
                                                label="Select Team"
                                                value={field.value || null}
                                                onChange={(_, newValue) => field.onChange(newValue?.id || null)}
                                                error={errors?.teamId}
                                            />
                                        )}
                                    />
                                </div>
                                {teamEmails?.length === 0 && (
                                    <p className="text-red-500 text-sm font-medium text-center mt-2">
                                        The team has no members, Members are required.
                                    </p>
                                )}
                            </div>
                        )
                    }
                    {
                        activeStep === 2 && (
                            <div className="grid grid-cols-1 gap-4">
                                {
                                    events?.length === 0 && (
                                        <p className="text-gray-600 text-sm font-medium text-center mt-2">
                                            No meeting types found. Create a meeting type in <Link to={'/dashboard/calendarsettings'} target='_blank' rel='noopener noreferrer' className='text-blue-500 font-semibold'>Calendar Settings</Link> before continue.
                                        </p>
                                    )
                                }
                                <Controller
                                    name="calAetId"
                                    control={control}
                                    rules={{ required: "Meeting type is required" }}
                                    render={({ field }) => (
                                        <div className="grid grid-cols-1 gap-4">
                                            {events?.map((event, index) => {
                                                const isSelected = field.value === event.id;
                                                // Curated custom colors to match mockup styles (blue, yellow, etc.)
                                                const colorsList = [
                                                    { border: 'border-blue-500', ring: 'ring-blue-500', bg: 'bg-blue-50/10' },
                                                    { border: 'border-amber-500', ring: 'ring-amber-500', bg: 'bg-amber-50/10' },
                                                    { border: 'border-emerald-500', ring: 'ring-emerald-500', bg: 'bg-emerald-50/10' },
                                                    { border: 'border-purple-500', ring: 'ring-purple-500', bg: 'bg-purple-50/10' },
                                                ];
                                                const color = colorsList[index % colorsList.length];

                                                return (
                                                    <div
                                                        key={event.id}
                                                        onClick={() => field.onChange(event.id)}
                                                        className={`cursor-pointer border-2 rounded-lg p-5 bg-white ${isSelected
                                                            ? `ring-2 ${color.ring} ${color.bg} shadow-md ${color.border}`
                                                            : 'shadow-sm hover:border-yellow-400'
                                                            }`}
                                                    >
                                                        <div className="flex flex-col gap-3">
                                                            <div className="flex items-center gap-3">
                                                                <CustomIcons iconName="fa-regular fa-calendar-check" css="text-black text-xl" />
                                                                <span className="font-semibold text-lg text-black">{event.title}</span>
                                                            </div>
                                                            <div className="flex items-center gap-3">
                                                                <CustomIcons iconName="fa-regular fa-clock" css="text-black text-lg" />
                                                                <span className="text-gray-700 text-sm font-medium">
                                                                    {formatDuration(event.durationHours, event.durationMinutes)}
                                                                </span>
                                                            </div>
                                                            {event.description && (
                                                                <p className="text-gray-600 text-sm whitespace-pre-line mt-1">
                                                                    {event.description}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                />
                                {errors?.calAetId && (
                                    <p className="text-red-500 text-sm font-medium text-center mt-2">
                                        {errors.calAetId.message}
                                    </p>
                                )}
                            </div>
                        )
                    }
                    {
                        activeStep === 3 && (
                            <div className="grid grid-cols-1">
                                {selectedEvent && (
                                    <div className="flex items-center justify-center gap-3 text-black text-2xl font-semibold mb-2">
                                        <CustomIcons iconName="fa-regular fa-clock" css="text-black text-2xl" />
                                        <span>{formatDuration(selectedEvent.durationHours, selectedEvent.durationMinutes)}</span>
                                    </div>
                                )}

                                <div className="flex flex-col md:flex-row justify-center items-start gap-8 max-w-2xl w-full mx-auto mb-6">
                                    {/* Calendar Column */}
                                    <div className="flex-1 flex flex-col items-center bg-white p-2 rounded-lg border border-gray-100 shadow-sm">
                                        <ThemeProvider theme={customTheme}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DateCalendar
                                                    value={selectedDate}
                                                    onChange={(newDate) => setSelectedDate(newDate)}
                                                    views={['day']}
                                                    minDate={dayjs()}
                                                    slots={{
                                                        day: CustomDay,
                                                    }}
                                                    slotProps={{
                                                        day: {
                                                            selectedSlotsCountMap,
                                                        }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </ThemeProvider>

                                        {/* Selected Days Pills */}
                                        {Object.keys(selectedSlotsCountMap).length > 0 && (
                                            <div className="w-full mt-2 pt-3 border-t border-gray-100 px-2">
                                                <div className="flex items-center justify-between text-xs text-gray-700 font-semibold mb-1.5">
                                                    <span>Selected Days ({Object.keys(selectedSlotsCountMap).length}/5):</span>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setSelectedSlots([]);
                                                            setValue("start", "");
                                                            setValue("end", "");
                                                        }}
                                                        className="text-amber-700 hover:text-amber-900 font-normal text-[11px] underline"
                                                    >
                                                        Clear all
                                                    </button>
                                                </div>
                                                {/* <div className="flex flex-wrap gap-1.5">
                                                    {Object.keys(selectedSlotsCountMap).map((dateStr) => {
                                                        const count = selectedSlotsCountMap[dateStr];
                                                        const isViewing = selectedDate.format("MM/DD/YYYY") === dateStr;
                                                        return (
                                                            <button
                                                                key={dateStr}
                                                                type="button"
                                                                onClick={() => setSelectedDate(dayjs(dateStr, "MM/DD/YYYY"))}
                                                                className={`px-2 py-1 rounded-md text-xs font-medium flex items-center gap-1.5 transition-all ${
                                                                    isViewing
                                                                        ? 'bg-amber-600 text-white shadow-xs'
                                                                        : 'bg-amber-50 text-amber-900 border border-amber-200 hover:bg-amber-100'
                                                                }`}
                                                                title="Click to view slots for this day"
                                                            >
                                                                <span>{dateStr}</span>
                                                                <span className={`px-1.5 py-0.2 rounded-full text-[10px] font-bold ${
                                                                    isViewing ? 'bg-white text-amber-700' : 'bg-amber-200 text-amber-900'
                                                                }`}>
                                                                    {count}
                                                                </span>
                                                            </button>
                                                        );
                                                    })}
                                                </div> */}
                                            </div>
                                        )}
                                    </div>

                                    {/* Slots Column */}
                                    <div className="w-full md:w-56 flex flex-col items-center md:items-start">
                                        <div className="flex items-center justify-between w-full mb-1">
                                            <p className="text-gray-900 font-semibold text-lg">
                                                {selectedDate.format("MM/DD/YYYY")}
                                            </p>
                                            {selectedSlotsCountMap[selectedDate.format("MM/DD/YYYY")] > 0 ? (
                                                <span className="text-xs font-bold text-amber-700 bg-amber-100 border border-amber-300 px-2 py-0.5 rounded-full">
                                                    {selectedSlotsCountMap[selectedDate.format("MM/DD/YYYY")]} selected
                                                </span>
                                            ) : (
                                                <span className="text-xs text-gray-400 font-medium">
                                                    0 selected
                                                </span>
                                            )}
                                        </div>
                                        {/* {selectedSlots.length > 0 && (
                                            <div className="text-xs text-gray-500 mb-3 w-full text-left">
                                                <span>
                                                    Total: <strong className="text-amber-600">{selectedSlots.length}</strong> slot{selectedSlots.length > 1 ? 's' : ''} across <strong className="text-amber-600">{Object.keys(selectedSlotsCountMap).length}</strong> day{Object.keys(selectedSlotsCountMap).length > 1 ? 's' : ''}
                                                </span>
                                            </div>
                                        )} */}

                                        {slotsLoading ? (
                                            <p className="text-gray-500 text-sm py-4">Loading slots...</p>
                                        ) : slots?.length > 0 ? (
                                            <div className="flex flex-col gap-3 w-full max-h-72 overflow-y-auto pr-1">
                                                {slots.map((slot) => {
                                                    const dateStr = selectedDate.format("MM/DD/YYYY");
                                                    const slotStartVal = `${dateStr} ${slot}`;
                                                    const isSelected = selectedSlots.some(s => s.start === slotStartVal);

                                                    return (
                                                        <button
                                                            key={slot}
                                                            type="button"
                                                            onClick={() => handleSelectSlot(slot)}
                                                            className={`w-full py-2.5 px-4 text-center text-sm font-semibold rounded-md border-2 transition-all duration-150 flex items-center justify-between ${isSelected
                                                                ? "border-amber-500 bg-amber-50/50 text-black font-bold shadow-sm ring-1 ring-amber-500"
                                                                : "border-gray-300 text-black hover:border-gray-400 bg-white"
                                                                }`}
                                                        >
                                                            <span>{formatSlotTime(slot)}</span>
                                                            {isSelected && (
                                                                <CustomIcons iconName="fa-solid fa-check" css="text-amber-600 text-sm" />
                                                            )}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <p className="text-gray-500 text-sm py-4 text-center md:text-left">No slots available</p>
                                        )}

                                        <input type="hidden" {...register("start", { required: "Please select a time slot" })} />
                                        {errors?.start && selectedSlots.length === 0 && (
                                            <p className="text-red-500 text-xs font-semibold mt-2 text-center md:text-left">
                                                Please select at least one time slot
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="mb-6 max-w-md w-full mx-auto">
                                    <p className="mb-2 text-black text-left text-sm font-medium">Select Timezone</p>
                                    <div className="flex items-center gap-3">
                                        <CustomIcons iconName="fa-solid fa-globe" css="text-gray-700 text-xl" />
                                        <div className="flex-1">
                                            <Controller
                                                name="memTimeZone"
                                                control={control}
                                                rules={{ required: "Timezone is required" }}
                                                render={({ field }) => (
                                                    <Select
                                                        options={timeZoneList}
                                                        value={field.value || null}
                                                        onChange={(_, newValue) => field.onChange(newValue?.id || null)}
                                                        error={errors?.memTimeZone}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        activeStep === 4 && (
                            <div className="flex flex-col md:flex-row gap-8 md:divide-x divide-gray-200 bg-white p-6 rounded-lg border border-gray-200 shadow-sm text-left">
                                {/* Left Column: Event Summary */}
                                <div className="flex-1 md:pr-8 space-y-4 text-black">
                                    {selectedEvent && (
                                        <>
                                            <h2 className="text-3xl font-bold text-gray-900 leading-tight">
                                                {selectedEvent.title}
                                            </h2>
                                            <div className="flex items-center gap-3 text-gray-700 font-semibold text-base">
                                                <CustomIcons iconName="fa-regular fa-clock" css="text-gray-600 text-lg" />
                                                <span>{formatDuration(selectedEvent.durationHours, selectedEvent.durationMinutes)}</span>
                                            </div>
                                            {selectedSlots?.length > 0 && (
                                                <div className="space-y-2">
                                                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                                        Selected Time Slot{selectedSlots.length > 1 ? 's' : ''} ({selectedSlots.length})
                                                    </span>
                                                    <div className="space-y-1.5 max-h-48 overflow-y-auto pr-1">
                                                        {selectedSlots.map((slot, index) => (
                                                            <div key={index} className="flex items-center gap-2.5 text-gray-800 font-semibold text-sm bg-gray-50 p-2 rounded border border-gray-200">
                                                                <CustomIcons iconName="fa-regular fa-calendar-check" css="text-amber-600 text-sm" />
                                                                <span>
                                                                    {dayjs(slot.start, "MM/DD/YYYY HH:mm:ss").format("hh:mm A")} - {dayjs(slot.end, "MM/DD/YYYY HH:mm:ss").format("hh:mm A, MM/DD/YYYY")}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="flex items-center gap-3 text-gray-700 font-semibold text-base">
                                                <CustomIcons iconName="fa-solid fa-globe" css="text-gray-600 text-lg" />
                                                <span>
                                                    {timeZoneList?.find(tz => tz.id === watch("memTimeZone"))?.title || watch("memTimeZone")}
                                                </span>
                                            </div>
                                            {selectedEvent.description && (
                                                <p className="text-gray-650 text-sm mt-4 leading-relaxed border-t border-gray-150 pt-4 font-medium">
                                                    {selectedEvent.description}
                                                </p>
                                            )}
                                        </>
                                    )}
                                </div>

                                {/* Right Column: Enter Details */}
                                <div className="flex-1 md:pl-8 space-y-6">
                                    <h2 className="text-2xl font-bold text-gray-950 text-center md:text-left">
                                        Enter Details
                                    </h2>

                                    {/* Guest Email(s) */}
                                    <div className="flex flex-col gap-1.5 w-full text-left">
                                        <span className="text-xs text-gray-500 font-medium">Guest Email(s)</span>
                                        <div
                                            onClick={handleWrapperClick}
                                            className="flex flex-wrap gap-2 items-center border-b border-gray-300 pb-2 cursor-text min-h-[40px] w-full"
                                        >
                                            {guestEmails.map((email, index) => (
                                                <Components.Chip
                                                    key={email}
                                                    label={email}
                                                    onDelete={() => handleRemoveGuestEmail(index)}
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: '#f1f1f1',
                                                        color: '#333333',
                                                        fontSize: '0.8125rem',
                                                        '& .MuiChip-deleteIcon': {
                                                            color: '#888888',
                                                            '&:hover': {
                                                                color: '#555555',
                                                            },
                                                        },
                                                    }}
                                                />
                                            ))}
                                            <input
                                                ref={inputRef}
                                                type="text"
                                                value={emailInput}
                                                onChange={(e) => setEmailInput(e.target.value)}
                                                onKeyDown={handleKeyDown}
                                                placeholder={guestEmails.length === 0 ? "Type email and press Enter..." : ""}
                                                className="flex-grow min-w-[150px] border-none outline-none text-sm text-gray-800 bg-transparent py-0.5"
                                            />
                                        </div>
                                    </div>

                                    {/* Description Notes */}
                                    <div className="space-y-2">
                                        <Controller
                                            name="description"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    {...field}
                                                    label="Please share anything that will help prepare for our meeting."
                                                    multiline={true}
                                                    rows={4}
                                                    placeholder="Add any details or notes here..."
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        activeStep === 5 && (
                            <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-md text-center max-w-lg mx-auto my-6 space-y-6">
                                <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto border border-green-200 shadow-sm">
                                    <CustomIcons iconName="fa-solid fa-circle-check" css="text-green-500 text-3xl" />
                                </div>
                                <div className="space-y-2">
                                    <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900">
                                        {isFromContacts
                                            ? `Meeting Scheduled with ${userDetails?.firstName ? `${userDetails.firstName} ${userDetails?.lastName || ''}`.trim() : 'Host'} !`
                                            : `Meeting Request Sent to ${userDetails?.firstName ? `${userDetails.firstName} ${userDetails?.lastName || ''}`.trim() : 'Host'} !`}
                                    </h2>
                                    <p className="text-gray-600 text-sm font-medium">
                                        {isFromContacts
                                            ? "Your meeting has been confirmed and added to the calendar."
                                            : "Your meeting request has been submitted and is pending approval."}
                                    </p>
                                </div>

                                {selectedEvent && (
                                    <div className="border border-gray-200 rounded-lg p-5 text-left space-y-3 mt-4 bg-gray-50 text-black">
                                        <div className="font-bold text-gray-900 text-base border-b border-gray-200 pb-2 flex justify-between items-center">
                                            <span>{selectedEvent.title}</span>
                                            <span className="text-xs font-medium text-gray-600 bg-white px-2 py-1 rounded border border-gray-200">
                                                {formatDuration(selectedEvent.durationHours, selectedEvent.durationMinutes)}
                                            </span>
                                        </div>

                                        <div className="space-y-1.5">
                                            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                                Selected Time Slot{selectedSlots.length > 1 ? 's' : ''} ({selectedSlots.length}):
                                            </p>
                                            {selectedSlots.map((slot, index) => (
                                                <div key={index} className="flex items-center gap-2 text-sm text-gray-800 font-semibold bg-white p-2 rounded border border-gray-200">
                                                    <CustomIcons iconName="fa-regular fa-calendar-check" css="text-amber-600 text-sm" />
                                                    <span>
                                                        {dayjs(slot.start, "MM/DD/YYYY HH:mm:ss").format("hh:mm A")} - {dayjs(slot.end, "MM/DD/YYYY HH:mm:ss").format("hh:mm A, MM/DD/YYYY")}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="flex items-center gap-2 text-sm text-gray-750 font-semibold pt-1">
                                            <CustomIcons iconName="fa-solid fa-globe" css="text-gray-600 text-sm" />
                                            <span>
                                                {timeZoneList?.find(tz => tz.id === watch("memTimeZone"))?.title || watch("memTimeZone")}
                                            </span>
                                        </div>

                                        <div className="border-t border-gray-200 pt-3 space-y-1.5 text-xs text-gray-700">
                                            <p><strong>Invitee:</strong> {watch("name")} ({watch("email")})</p>
                                            {guestEmails.length > 0 && (
                                                <p><strong>Guests:</strong> {guestEmails.join(", ")}</p>
                                            )}
                                            {watch("description") && (
                                                <p><strong>Notes:</strong> {watch("description")}</p>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <div className="space-y-2">
                                    <p className="text-gray-600 text-sm font-medium">
                                        {isFromContacts
                                            ? "A calendar invitation with meeting details has been sent to all attendees."
                                            : `An email request has been sent to ${userDetails?.firstName ? `${userDetails.firstName} ${userDetails?.lastName || ''}`.trim() : 'the host'} for approval. Once a slot is approved, the meeting will be added to your calendar.`}
                                    </p>
                                </div>
                            </div>
                        )
                    }
                    {
                        activeStep < 5 && (
                            <div className="mt-6">
                                <div className="flex justify-center items-center gap-3">
                                    <Button
                                        useFor="disabled"
                                        type="button"
                                        text="Cancel"
                                        onClick={() => window.close()}
                                    />
                                    {
                                        activeStep !== 0 && (
                                            <div>
                                                <Button type="button" onClick={() => handleBack()} text={"Back"} />
                                            </div>
                                        )
                                    }

                                    <div>
                                        <Button type="submit" disabled={activeStep === 2 ? events?.length === 0 : false} startIcon={activeStep === 4 ? <CustomIcons iconName="fa-regular fa-calendar-check" css="text-gray-600 text-sm" /> : null} text={activeStep === 4 ? "SCHEDULE MEETING" : "Next"} />
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </form>
            </div>
        </div>
    );
};

export default connect(null, { setAlert })(Appointment);